import { Color, Themes } from "@glossy";
import { getLightTheme } from "@glossy/theme/templates";

export const getLightThemes = (): Themes => ({
  surface: getLightTheme(),
  header: getLightTheme({
    content: {
      primary: Color.Black54,
      secondary: Color.Black87,
      tertiary: Color.Black65,
    },
    background: Color.Black06,
    border: Color.Black26,
  }),
  body: getLightTheme({ background: Color.Solitude }),
  tile: getLightTheme(),
  edition: getLightTheme({ background: Color.Solitude }),
});
